/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G4_DInputs */

const en_mk_sec_pg_g4_d = /** @type {(inputs: Mk_Sec_Pg_G4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent reads only the channels you name. Private channels and direct messages stay closed unless access is granted explicitly.`)
};

const id_mk_sec_pg_g4_d = /** @type {(inputs: Mk_Sec_Pg_G4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen hanya membaca channel yang ditentukan. Channel privat dan pesan langsung tertutup kecuali diberi akses eksplisit.`)
};

/**
* | output |
* | --- |
* | "An agent reads only the channels you name. Private channels and direct messages stay closed unless access is granted explicitly." |
*
* @param {Mk_Sec_Pg_G4_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g4_d = /** @type {((inputs?: Mk_Sec_Pg_G4_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G4_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g4_d(inputs)
	return en_mk_sec_pg_g4_d(inputs)
});